import axios from 'axios';
import { getPreferredLanguage } from '~/modules/helpers/languageHelper';
import { UserInfo } from '~/modules/services/userService';
import { getCookie } from '~/modules/utilities/cookies';
import { CORRELATION_ID_PARAM, randomUUID } from '~/modules/utilities/cross_env_utils';
import { handleException } from '~/modules/utilities/error_utilities';

type AuthCheckOptions = {
    skipRequestWithoutSid?: boolean;
};

// undefined is a confirmed unauthenticated response; null means the auth endpoint was unavailable.
// Keeping those states distinct lets protected routes avoid presenting a service failure as a login prompt.
export async function isLoggedIn(options: AuthCheckOptions = {}): Promise<UserInfo | undefined | null> {
    let userInfo: UserInfo | undefined;
    try {
        const sid = getCookie('sid');
        if (!sid && options.skipRequestWithoutSid) {
            return undefined;
        }
        const language = getPreferredLanguage();
        // Use a relative URL so the request always goes to the current origin's server,
        // which handles all domains (appexchange, appexchangejp, agentexchange).
        userInfo = await axios
            .post(
                '/api/auth',
                {
                    sid,
                    language,
                },
                {
                    headers: { [CORRELATION_ID_PARAM]: randomUUID() },
                },
            )
            .then(({ data }) => data);
    } catch (error) {
        if (axios.isAxiosError(error) && [401, 403].includes(error.response?.status ?? 0)) {
            return undefined;
        }
        handleException(error, 'authService.isLoggedIn');
        return null;
    }
    return userInfo;
}
